import { useEffect, useState } from "react";
import { supabase } from "../supabase.js";
import "../styles/admincoupons.css";

export default function AdminCoupons({ language = "en" }) {
    const [coupons, setCoupons] = useState([]);
  const [user, setUser] = useState(null);
const [orders, setOrders] = useState([]);
const [search, setSearch] = useState("");
const [statusFilter, setStatusFilter] = useState("all");
const [couponFilter, setCouponFilter] = useState("all");
// const [dateFrom, setDateFrom] = useState("");
// const [dateTo, setDateTo] = useState("");
const [serviceFilter, setServiceFilter] = useState("all");
const [orderId, setOrderId] = useState("");



useEffect(() => {
  const savedId = localStorage.getItem("orderId");
  setOrderId(savedId || "");
}, []);



const t = {
  en: {
    titleCoupons: "Coupon Management",
    titleOrders: "Orders Management",
    code: "Code",
    discount: "Discount Value",
    type: "Type",
    uses: "Uses",
    status: "Status",
    expires: "Expires",
    action: "Action",
    addCoupon: "Add Coupon",

    search: "Search by Ref (REQ-...)",
    allStatus: "All Status",
    pending: "Pending",
    paid: "Paid",
    allCoupons: "All Coupons",
    withCoupon: "With Coupon",
    withoutCoupon: "No Coupon",
    allServices: "All Services",

    ref: "Ref",
    name: "Name",
    email: "Email",
    coupon: "Coupon",
    service: "Service",
    total: "Total",
    date: "Date",

    markPaid: "Mark as Paid",
    markPending: "Mark as Pending",
  },

  ar: {
    titleCoupons: "إدارة الكوبونات",
    titleOrders: "إدارة الطلبات",
    code: "الكود",
    discount: "قيمة الخصم",
    type: "النوع",
    uses: "الاستخدام",
    status: "الحالة",
    expires: "تاريخ الانتهاء",
    action: "إجراء",
    addCoupon: "إضافة كوبون",

    search: "ابحث برقم الطلب (REQ-...)",
    allStatus: "كل الحالات",
    pending: "قيد الانتظار",
    paid: "مدفوع",
    allCoupons: "كل الكوبونات",
    withCoupon: "مع كوبون",
    withoutCoupon: "بدون كوبون",
    allServices: "كل الخدمات",

    ref: "الرقم",
    name: "الاسم",
    email: "البريد",
    coupon: "الكوبون",
    service: "الخدمة",
    total: "الإجمالي",
    date: "التاريخ",

    markPaid: "تحويل إلى مدفوع",
    markPending: "إرجاع إلى قيد الانتظار",
  },
}[language];






  const [form, setForm] = useState({
  code: "",
  type: "percent",
  value: "100",
  max_uses: "",
  expires_at: "",
});

  // 🔐 جلب المستخدم الحالي
  const getUser = async () => {
    const {
      data: { user },
    } = await supabase.auth.getUser();

    setUser(user);
    return user;
  };

  // 📥 جلب كوبونات المالك فقط
  const fetchCoupons = async (currentUser) => {
  if (!currentUser) return;

  const today = new Date().toISOString();

  const { data, error } = await supabase
    .from("coupons")
    .select("*")
    .eq("owner_id", currentUser.id)
    .order("created_at", { ascending: false });

  if (!error) {
    const updated = data.map((c) => {
      const expired = c.expires_at && new Date(c.expires_at) < new Date();

      return {
        ...c,
        active: expired ? false : c.active,
      };
    });

    setCoupons(updated);
  } else {
    console.log(error);
  }
};
const fetchOrders = async () => {
  const { data, error } = await supabase
    .from("orders")
    .select("*")
    .order("created_at", { ascending: false });

  if (!error) {
    setOrders(data);
  } else {
    console.log(error);
  }
};
const updateStatus = async (id, currentStatus) => {
  const newStatus = currentStatus === "pending" ? "paid" : "pending";

  const { error } = await supabase
    .from("orders")
    .update({ status: newStatus })
    .eq("id", id);

  if (!error) fetchOrders();
};
const disableExpiredCoupons = async (currentUser) => {
  const now = new Date().toISOString();

  await supabase
    .from("coupons")
    .update({ active: false })
    .lt("expires_at", now)
    .eq("owner_id", currentUser.id);
};

 useEffect(() => {
  const init = async () => {
    const u = await getUser();

    if (u) {
      await disableExpiredCoupons(u); // 🔥 مهم
      fetchCoupons(u);
      fetchOrders();
    }
  };

  init();
}, []);

  // ➕ إنشاء كوبون
  const handleAdd = async () => {
    if (!form.code || !form.value) {
      alert("Fill required fields");
      return;
    }

    const {
      data: { user },
    } = await supabase.auth.getUser();

    if (!user) {
      alert("Not logged in");
      return;
    }

    const { error } = await supabase.from("coupons").insert([
      {
        code: form.code.toUpperCase(),
        type: "percent",
value: 100,
        max_uses: form.max_uses ? Number(form.max_uses) : null,
        expires_at: form.expires_at || null,
        owner_id: user.id,
      },
    ]);

    if (error) {
      console.log(error);
      alert("Error adding coupon");
    } else {
    setForm({
  code: "",
  type: "percent",
  value: "100",
  max_uses: "",
  expires_at: "",
});

      fetchCoupons(user);
    }
  };

  // 🔄 تفعيل / تعطيل
  const toggleActive = async (id, current) => {
    const {
      data: { user },
    } = await supabase.auth.getUser();

    if (!user) return;

    const { error } = await supabase
      .from("coupons")
      .update({ active: !current })
      .eq("id", id)
      .eq("owner_id", user.id);

    if (!error) fetchCoupons(user);
  };
 const filteredOrders = orders.filter((o) => {
  // 🔍 البحث
  const searchValue = search.toLowerCase();

const matchesSearch =
  o.request_ref?.toLowerCase().includes(searchValue) ||
  o.email?.toLowerCase().includes(searchValue) ||
  o.full_name?.toLowerCase().includes(searchValue);
  // 📊 الحالة
  const matchesStatus =
    statusFilter === "all" || o.status === statusFilter;

  // 🎟 الكوبون
  const matchesCoupon =
    couponFilter === "all" ||
    (couponFilter === "with" && o.coupon_code) ||
    (couponFilter === "without" && !o.coupon_code);

  // 🛠 الخدمة
  const matchesService =
    serviceFilter === "all" ||
    o.service?.toLowerCase().includes(serviceFilter.toLowerCase());

  // 📅 التاريخ (اختياري إذا تستخدمه)
  // const orderDate = new Date(o.created_at);

  // const matchesDateFrom = dateFrom
  //   ? orderDate >= new Date(dateFrom)
  //   : true;

  // const matchesDateTo = dateTo
  //   ? orderDate <= new Date(dateTo + "T23:59:59")
  //   : true;

  return (
    matchesSearch &&
    matchesStatus &&
    matchesCoupon &&
    matchesService 
    // matchesDateFrom &&
    // matchesDateTo
  );
});

  return (
    <div className="admin-page">
    <div className="admin-page" dir={language === "ar" ? "rtl" : "ltr"}>

<h2 className="admin-title">🎟 {t.titleCoupons}</h2>
      {/* FORM */}
      <div className="coupon-form">
        <input
          placeholder="CODE (e.g. VIP50)"
          value={form.code}
          onChange={(e) => setForm({ ...form, code: e.target.value })}
        />

        {/* <select
          value={form.type}
          onChange={(e) => setForm({ ...form, type: e.target.value })}
        >
          <option value="percent">%</option>
          <option value="fixed">SAR</option>
        </select> */}

        {/* <input
          placeholder="Discount Value"
          value={form.value}
          onChange={(e) => setForm({ ...form, value: e.target.value })}
        /> */}

        <input
          placeholder="Max Uses"
          value={form.max_uses}
          onChange={(e) => setForm({ ...form, max_uses: e.target.value })}
        />

        <input
          type="date"
          value={form.expires_at}
          onChange={(e) => setForm({ ...form, expires_at: e.target.value })}
        />

        <button className="add-btn" onClick={handleAdd}>
          ➕ Add Coupon
        </button>
      </div>

      {/* TABLE */}
      <table className="coupon-table">
        <thead>
          <tr>

          <th>{t.code}</th>
<th>{t.discount}</th>
<th>{t.type}</th>
<th>{t.uses}</th>
<th>{t.status}</th>
<th>{t.expires}</th>
<th>{t.action}</th>
          </tr>
        </thead>

        <tbody>
          {coupons.map((c) => (
            <tr key={c.id}>
              <td>{c.code}</td>
              <td>{c.value}</td>
              <td>{c.type}</td>
              <td>
                {c.used_count} / {c.max_uses || "∞"}
              </td>

              <td className={c.active ? "status-active" : "status-disabled"}>
                {c.active ? "Active" : "Disabled"}
              </td>
              <td>
  {c.expires_at
    ? new Date(c.expires_at).toLocaleDateString()
    : "∞"}
</td>

              <td>
                <button
                  className="toggle-btn"
                  onClick={() => toggleActive(c.id, c.active)}
                >
                  {c.active ? "Disable" : "Enable"}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
        
      </table>
      <br />
      <h2 className="admin-title">{t.titleOrders}</h2>
<div className="filters">

  {/* 🔍 البحث */}
 <input
  placeholder={t.search}
  value={search}
  onChange={(e) => setSearch(e.target.value)}
/>

  {/* 📊 الحالة */}
  <select
    value={statusFilter}
    onChange={(e) => setStatusFilter(e.target.value)}
  >
   <option value="all">{t.allStatus}</option>
<option value="pending">{t.pending}</option>
<option value="paid">{t.paid}</option>
  </select>

  {/* 🎟 الكوبون */}
  <select
    value={couponFilter}
    onChange={(e) => setCouponFilter(e.target.value)}
  >
   <option value="all">{t.allCoupons}</option>
<option value="with">{t.withCoupon}</option>
<option value="without">{t.withoutCoupon}</option>
  </select>
{/* 📅 من تاريخ */}
{/* <input
  type="date"
  value={dateFrom}
  onChange={(e) => setDateFrom(e.target.value)}
/> */}

{/* 📅 إلى تاريخ */}
{/* <input
  type="date"
  value={dateTo}
  onChange={(e) => setDateTo(e.target.value)}
/> */}

{/* 🛠 الخدمة */}
<select
  value={serviceFilter}
  onChange={(e) => setServiceFilter(e.target.value)}
>
  <option value="all">{t.allServices}</option>
  <option value="feasibility1">
    {language === "ar"
      ? "الدراسة الفنية والتشغيلية"
      : "Technical & Operational Study"}
  </option>
  <option value="feasibility2">
    {language === "ar"
      ? "دراسات السوق والتحليل التجاري"
      : "Market Studies & Business Analysis"}
  </option>
</select>
</div>

<table className="coupon-table">
 <thead>
  <tr>
    <th>{t.ref}</th>
    <th>{t.name}</th>
    <th>{t.email}</th>
    <th>{t.coupon}</th>
    <th>{t.service}</th>
    <th>{t.total}</th>
    <th>{t.status}</th>
    <th>{t.date}</th>
    <th>{t.action}</th>
  </tr>
</thead>

  <tbody>
  {filteredOrders.map((o) => (
    <tr key={o.id}>
      <td>{o.request_ref}</td>
      <td>{o.full_name}</td>
      <td>{o.email}</td>

      {/* 🎟 الكوبون */}
      <td>{o.coupon_code ? o.coupon_code : "-"}</td>

      {/* 🛠 الخدمة مترجمة */}
      <td>
        {o.service === "feasibility1"
          ? language === "ar"
            ? "الدراسة الفنية والتشغيلية"
            : "Technical & Operational Study"
          : o.service === "feasibility2"
          ? language === "ar"
            ? "دراسات السوق والتحليل التجاري"
            : "Market Studies & Business Analysis"
          : o.service}
      </td>

      {/* 💰 السعر */}
      <td>{o.total} SAR</td>

      {/* 📊 الحالة */}
      <td
        className={
          o.status === "paid" ? "status-active" : "status-disabled"
        }
      >
        {o.status === "pending" ? t.pending : t.paid}
      </td>

      {/* 📅 التاريخ */}
      <td>
        {new Date(o.created_at).toLocaleDateString(
          language === "ar" ? "ar-EG" : "en-US"
        )}
      </td>

      {/* 🔘 الزر */}
      <td>
        <button
          className="toggle-btn"
          onClick={() => updateStatus(o.id, o.status)}
        >
          {o.status === "pending" ? t.markPaid : t.markPending}
        </button>
      </td>
    </tr>
  ))}
</tbody>
</table>
    </div>
    </div>
  );
}
